import Api from '@/vuex/api'
import { app } from '@/main'
import {
  ADD_FORM_FIELD,
  CLOSE_MODAL,
  CLOSE_FORM,
  CLOSE_MODAL_FORM,
  CLEAR_MODALS,
  COMPONENT_METHOD,
  DELETE_NOTE,
  DELETE_QUOTE_NOTE,
  EDIT_NOTE,
  EDIT_QUOTE_NOTE,
  EXPIRED_SESSION,
  GET_FORM_FIELD,
  GET_FORM_VALUE,
  LIVE_FEED,
  OCMANAGERS_FEED,
  LOAD_COMPANY_CONTRACTORS,
  LOAD_COMPANY_MANAGERS,
  LOAD_COMPANY_PROPERTIES,
  LOAD_DASHBOARD,
  LOAD_DATA,
  LOAD_FORM,
  LOAD_QUOTES,
  LOAD_QUOTE_NOTES,
  LOAD_REPORTS,
  LOAD_SIDEBAR,
  LOAD_STATS,
  LOGIN,
  LOGOUT,
  LOAD_SETTINGS,
  MODIFY_FORM_VALUE,
  MODIFY_FORM_FIELD,
  OPEN_CONFIRMATION_MODAL,
  OPEN_ERROR_MODAL,
  OPEN_MODAL,
  REMOVE_FORM_FIELD,
  LOAD_PROPERTY_CONTRACTORS,
  LOAD_PROPERTY_NOTES,
  LOAD_PROPERTY_PHOTOS,
  SUBMIT_FORM,
  LOAD_TICKET,
  CLOSE_TICKET,
  REOPEN_TICKET,
  DELETE_TICKET,
  ADD_TICKET_PRIORITY,
  REMOVE_TICKET_PRIORITY,
  LOAD_CARDS,
  FEEDBACK
} from '@/vuex/types'

const api = new Api()
const state = {
  expiredSession: false,
  modals: [],
  forms: [],
  settings: {
    pageTitle: 'Roscon Admin',
    stylesheet: false
  },
  dashboard: {},
  stats: {},
  liveFeed: [],
  feedback: [],
  ocManagersFeed: [],
  loggedIn: true,
  cards: {
    columns: [],
    permalink: false,
    rows: [],
    links: [],
    noResults: '',
    offset: 0,
    limit: 10,
    searchForm: {
      fields: []
    }
  },
  ticket: {
    labels: [],
    notes: []
  },
  priorityActions: [
    { label: 'High Priority', command: 'addTicketPriorityHigh', icon: 'fa fa-plus-circle' },
    { label: 'Medium Priority', command: 'addTicketPriorityMedium', icon: 'fa fa-plus-circle' },
    { label: 'Low Priority', command: 'addTicketPriorityLeast', icon: 'fa fa-plus-circle' },
    { label: 'Remove Priority', command: REMOVE_TICKET_PRIORITY, icon: 'fa fa-trash' }
  ]
}

const mutations = {
  [OPEN_MODAL] (context, modal) {
    context.modals = [ ...context.modals, modal ]
  },
  [CLOSE_MODAL] (context, index) {
    if (index >= 0) {
      let modals = context.modals
      if (modals[index].redirect) {
        app.$router.push(modals[index].redirect, function () {}, function () {
          app.$router.push({
            path: modals[index].redirect + '?t=' + new Date().getTime()
          })
        })
      }
      modals.splice(index, 1)
      context.modals = modals
    } else {
      throw new Error('Could not find modal to remove')
    }
  },
  [CLOSE_FORM] (context, permalink) {
    let forms = context.forms
    let _forms = []
    for (let form of forms) {
      if (form.permalink !== permalink) {
        _forms.push(form)
      }
    }
    context.forms = _forms
  },
  [CLOSE_MODAL_FORM] (context, permalink) {
    let forms = []
    let modals = []
    for (let form of context.forms) {
      if (form.permalink !== permalink) {
        forms.push(form)
      }
    }
    for (let modal of context.modals) {
      if (modal.permalink !== permalink) {
        modals.push(modal)
      }
    }
    context.modals = modals
    context.forms = forms
  },
  [CLEAR_MODALS] (context) {
    context.modals = []
  },
  [LOAD_FORM] ({ forms }, form) {
    forms.push(form)
  },
  [LOAD_DASHBOARD] (context, dashboard) {
    context.dashboard = dashboard
  },
  [LOAD_STATS] (context, stats) {
    context.stats = stats
  },
  [MODIFY_FORM_VALUE] (context, { permalink, name, value }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          forms[found].sections[j].value = value
        }
      }
      context.forms = [ ...forms ]
    }
  },
  [REMOVE_FORM_FIELD] (context, { permalink, name }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          forms[found].sections.splice(j, 1)
        }
      }
    }
    context.forms = [ ...forms ]
  },
  [ADD_FORM_FIELD] (context, { permalink, field }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      let sections = forms[found].sections
      sections.push(field)
      context.forms = [ ...forms ]
    }
  },
  [MODIFY_FORM_FIELD] (context, { permalink, name, field }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          forms[found].sections[j] = field
        }
      }
      context.forms = [ ...forms ]
    }
  },
  [EXPIRED_SESSION] (context, expiredSession) {
    context.expiredSession = expiredSession
  },
  [LIVE_FEED] (context, feed) {
    context.liveFeed = feed
  },
  [FEEDBACK] (context, feed) {
    context.feedback = feed
  },
  [OCMANAGERS_FEED] (context, feed) {
    context.ocManagersFeed = feed
  },
  [LOAD_SETTINGS] (context, settings) {
    context.settings = { ...context.settings, ...settings }
  },
  [LOGIN] (state) {
    state.loggedIn = true
  },
  [LOGOUT] (state) {
    state.loggedIn = false
  },
  [LOAD_TICKET] (state, ticket) {
    state.ticket = ticket
  },
  [LOAD_CARDS] (context, cards) {
    context.cards = cards
  }
}

const actions = {
  async [LIVE_FEED] (context, options) {
    let data = await api.getRecentActivity(options)
    context.commit(LIVE_FEED, data)
  },
  async [OPEN_MODAL] (context, modal) {
    context.commit(OPEN_MODAL, modal)
  },
  async [OPEN_ERROR_MODAL] (context, error) {
    context.commit(CLEAR_MODALS)
    let errorMessage = error.data || error.message
    let errorModal = {
      title: 'Error Processing Request',
      html: '<div class="alert alert-danger">' + errorMessage + '</div>'
    }
    context.dispatch(OPEN_MODAL, errorModal)
  },
  async [OPEN_CONFIRMATION_MODAL] (context, payload) {
    context.commit(CLEAR_MODALS)
    if (payload.permalink) {
      context.commit(CLOSE_FORM, payload.permalink)
    }
    let confirmationModal = {
      title: 'Success',
      html: '<p>' + payload.confirmation + '</p>',
      redirect: payload.redirect || false
    }
    context.dispatch(OPEN_MODAL, confirmationModal)
  },
  async [LOAD_FORM] (context, opts) {
    try {
      let form = await api.getForm(opts.permalink, opts.params, opts.auth)
      context.commit(LOAD_FORM, form)
    } catch (err) {
      throw err
    }
  },
  async [SUBMIT_FORM] (context, opts) {
    let response = {}
    try {
      response = await api.submitForm(opts.data, opts.method, opts.auth)
    } catch (err) {
      throw err
    }
    switch (opts.data.permalink) {
      case 'adminLogin':
        context.dispatch(LOGIN, response.token)
        context.commit(EXPIRED_SESSION, false)
        break
      case 'getLiveFeed':
        context.commit(LIVE_FEED, response)
        break
      case 'getFeedback':
        context.commit(FEEDBACK, response)
        break
      case 'getOCManagersFeed':
        context.commit(OCMANAGERS_FEED, response)
        break
      case 'getPropertyNotes':
      case 'addPropertyNote':
        context.commit(LOAD_PROPERTY_NOTES, response)
        break
      case 'getQuoteNotes':
      case 'addQuoteNote':
      case 'editQuoteNote':
      case 'deleteQuoteNote':
        context.commit(LOAD_QUOTE_NOTES, response)
        break
      case 'addPropertyPhoto':
      case 'getPropertyPhotos':
      case 'deletePropertyPhoto':
        context.commit(LOAD_PROPERTY_PHOTOS, response)
        break
      case 'generateIncidentPdf':
      case 'deleteReport':
      case 'uploadIncidentPdf':
      case 'sendIncidentReportEmail':
      case 'generateInspectionPdf':
      case 'uploadInspectionPdf':
      case 'sendInspectionReportEmail':
      case 'sendTaxInvoiceRequest':
      case 'deleteTaxInvoiceRequest':
      case 'sendPropertyPhotosReportEmail':
      case 'generatePropertyPhotosPdf':
      case 'asbestosReport':
      case 'asbestosReportPdf':
      case 'generateAsbestosReportPdf':
      case 'sendAsbestosReportEmail':
      case 'ohsReport':
      case 'ohsReportPdf':
      case 'generateOhsReportPdf':
      case 'sendOhsReportEmail':
      case 'esmReport':
      case 'esmReportPdf':
      case 'generateEsmReportPdf':
      case 'sendEsmReportEmail':
      case 'uploadDefectsPdf':
      case 'sendDefectsReportEmail':
      case 'defectsReport':
      case 'defectsReportPdf':
      case 'generateDefectsReportPdf':
      case 'sendInsuranceReportEmail':
      case 'insuranceReport':
      case 'insuranceReportPdf':
      case 'generateInsuranceReportPdf':
      case 'tradesReportQuickSave':
      case 'tradesReport':
      case 'tradesReportPdf':
      case 'generateTradesPdf':
      case 'uploadTradesPdf':
      case 'sendTradesReportEmail':
        context.dispatch(LOAD_REPORTS)
        break
      case 'acceptQuote':
      case 'sendQuote':
      case 'deleteQuote':
        context.dispatch(LOAD_QUOTES)
        break
      case 'newInvoiceCode':
      case 'editInvoiceCode':
      case 'deleteInvoiceCode':
      case 'editStaff':
      case 'newStaff':
      case 'deleteStaff':
      case 'newManager':
      case 'editManager':
      case 'deleteManager':
      case 'newProperty':
      case 'newEPMA':
      case 'editProperty':
      case 'editEPMA':
      case 'sendEPMAEmail':
      case 'invoiceEPMA':
      case 'requestEPMASignature':
      case 'newCompany':
      case 'editCompany':
      case 'editCompanyMasterNote':
      case 'newOhsLocation':
      case 'editOhsLocation':
      case 'deleteOhsLocation':
      case 'newOhsFinding':
      case 'editOhsFinding':
      case 'deleteOhsFinding':
      case 'newEsmItem':
      case 'editEsmItem':
      case 'deleteEsmItem':
      case 'newEsmTemplate':
      case 'editEsmTemplate':
      case 'deleteEsmTemplate':
      case 'uploadReportIcon':
      case 'newReportType':
      case 'newPropertyCosting':
      case 'editPropertyCosting':
      case 'deletePropertyCosting':
      case 'addReportPricing':
      case 'editReportPricing':
      case 'deleteReportType':
      case 'editReportType':
      case 'newVideo':
      case 'editVideo':
      case 'deleteVideo':
      case 'deleteCompany':
        if (opts.reload) {
          context.commit(opts.reload, response)
        } else if (app.$router.currentRoute.meta.reload) {
          context.commit(app.$router.currentRoute.meta.reload, response)
        } else {
          context.dispatch(LOAD_DATA)
        }
        break
      case 'deleteProperty':
        if (opts.reload) {
          context.commit(opts.reload, response)
        } else if (opts.data.client) {
          app.$router.push('/client/manage-properties#properties')
        } else {
          app.$router.push('/database-manager/properties')
        }
        break
      case 'uploadAppIcon':
        context.dispatch(LOAD_DATA)
        context.dispatch(LOAD_SIDEBAR)
        break
      case 'deleteNote':
      case 'editNote':
        context.commit(response.action, response)
        break
      case 'newPropertyContractor':
      case 'getPropertyContractors':
      case 'selectPropertyContractors':
        context.commit(LOAD_PROPERTY_CONTRACTORS, response)
        break
      case 'getCompanyManagers':
      case 'newCompanyManager':
      case 'editCompanyManager':
      case 'deleteCompanyManager':
        context.commit(LOAD_COMPANY_MANAGERS, response)
        break
      case 'getCompanyProperties':
        context.commit(LOAD_COMPANY_PROPERTIES, response)
        break
      case 'getCompanyContractors':
      case 'editContractor':
      case 'newContractor':
      case 'deleteContractor':
        if (response) {
          context.commit(LOAD_COMPANY_CONTRACTORS, response)
        } else {
          context.dispatch(LOAD_DATA)
        }
        break
    }
  },
  async [LOAD_DASHBOARD] (context, date) {
    let liveFeed = await api.getRecentActivity()
    let dashboard = await api.getDashboard(date)
    context.commit(LIVE_FEED, liveFeed)
    context.commit(LOAD_DASHBOARD, dashboard)
  },
  async [LOAD_STATS] (context, payload) {
    let stats = await api.getStats(payload)
    context.commit(LOAD_STATS, stats)
  },
  async [LOAD_SETTINGS] (context) {
    let settings = await api.loadSettings()
    context.commit(LOAD_SETTINGS, settings)
  },
  [DELETE_NOTE] (context, uuid) {
    let deleteNoteModal = {
      permalink: 'deleteNote',
      options: {
        title: 'Confirm Delete',
        actionLabel: 'Delete'
      },
      params: {
        uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteNoteModal)
  },
  [EDIT_NOTE] (context, uuid) {
    let editNoteModal = {
      permalink: 'editNote',
      options: {
        title: 'Edit Note',
        actionLabel: 'Save'
      },
      params: {
        uuid
      }
    }
    context.dispatch(OPEN_MODAL, editNoteModal)
  },
  [DELETE_QUOTE_NOTE] (context, uuid) {
    let deleteQuoteNoteModal = {
      permalink: 'deleteQuoteNote',
      options: {
        title: 'Confirm Delete',
        actionLabel: 'Delete'
      },
      params: {
        uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteQuoteNoteModal)
  },
  [EDIT_QUOTE_NOTE] (context, uuid) {
    let editQuoteNoteModal = {
      permalink: 'editQuoteNote',
      options: {
        title: 'Edit Note',
        actionLabel: 'Save'
      },
      params: {
        uuid
      }
    }
    context.dispatch(OPEN_MODAL, editQuoteNoteModal)
  },
  [LOGIN] (context, token) {
    window.sessionStorage.setItem('token', token)
    context.commit(LOGIN)
  },
  async [LOGOUT] (context) {
    context.commit(LOGOUT)
    try {
      await api.logout()
    } catch (err) {
      console.log(err)
    }
    window.sessionStorage.removeItem('token')
  },
  [COMPONENT_METHOD] (context, args) {
    for (let component of args.payload) {
      component[args.method]()
    }
  },
  async [LOAD_TICKET] (context, ticketId) {
    let ticket = await api.getTicket(ticketId)
    context.commit(LOAD_TICKET, ticket)
  },
  async [CLOSE_TICKET] (context, ticketId) {
    await api.closeTicket(ticketId)
  },
  async [REOPEN_TICKET] (context, ticketId) {
    await api.reopenTicket(ticketId)
  },
  async [DELETE_TICKET] (context, ticketId) {
    await api.deleteTicket(ticketId)
  },
  async [ADD_TICKET_PRIORITY] (context, ticketDetail) {
    await api.addTicketPriority(ticketDetail)
  },
  async [REMOVE_TICKET_PRIORITY] (context, ticketId) {
    await api.removeTicketPriority(ticketId)
  },
  async [LOAD_CARDS] (context, options) {
    let cards = await api.getCards(options)
    context.commit(LOAD_CARDS, cards)
  }
}

const getters = {
  priorityActions ({ priorityActions }) {
    return priorityActions
  },
  modals ({ modals }) {
    return modals
  },
  getActiveModal ({ modals }) {
    return modals.length ? modals[modals.length - 1] : false
  },
  forms ({ forms }) {
    return forms
  },
  liveFeed ({ liveFeed }) {
    return liveFeed
  },
  feedback ({ feedback }) {
    return feedback
  },
  ocManagersFeed ({ ocManagersFeed }) {
    return ocManagersFeed
  },
  getForm: ({ forms }) => (permalink) => {
    return forms.find(f => f.permalink === permalink)
  },
  [GET_FORM_VALUE]: ({ forms }) => ({ permalink, name }) => {
    let found = false
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          return forms[found].sections[j].value
        }
      }
    }
    return false
  },
  [GET_FORM_FIELD]: ({ forms }) => ({ permalink, name }) => {
    let found = false
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          return forms[found].sections[j]
        }
      }
    }
    return false
  },
  dashboard ({ dashboard }) {
    return dashboard
  },
  expiredSession ({ expiredSession }) {
    return expiredSession
  },
  settings ({ settings }) {
    return settings
  },
  stats ({ stats }) {
    return stats
  },
  isLoggedIn ({ loggedIn }) {
    return loggedIn
  },
  cards ({ cards }) {
    return cards
  },
  cardsSearchForm ({ cards }) {
    return cards.searchForm.fields.concat([
      { name: 'limit', label: 'Limit per page', fullWidth: true, type: 'search', value: cards.limit }
    ])
  },
  ticket ({ ticket }) {
    return ticket
  },
  loadedCards ({ cards }) {
    return cards
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/application.js